export const presentation = [
  {
    height: 280,
    size: 48,
  },
  {
    height: 245,
    size: 48,
  },
  {
    height: 190,
    size: 40,
  },
  {
    height: 150,
    size: 35,
  },
  {
    height: 150,
    size: 35,
  },
];

export const navBar = [
  {
    itemWidth: 140,
    itemSize: 16,
    barHeight: 75,
  },
  {
    itemWidth: 140,
    itemSize: 16,
    barHeight: 75,
  },
  {
    itemWidth: 120,
    itemSize: 15,
    barHeight: 75,
  },
  {
    itemWidth: 100,
    itemSize: 13,
    barHeight: 70,
  },
  {
    itemWidth: 100,
    itemSize: 13,
    barHeight: 70,
  },
];
